module.exports = __webpack_public_path__ + "static/media/gears.0873973e.png";